module.exports = __webpack_public_path__ + "media/customizations/pomonalife/logo-62c87c055bf478d350ff55aeebb63620.png";